import { MainWrapperStylesProps } from './types';
import { Text } from 'features/common/components/Text';
import { hideScrollbar } from 'styles';
import styled from 'styled-components';

export const Title = styled(Text)`
	line-height: 27px;
	margin: 20px 3%;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		font-size: 18px;
		margin-left: 3%;
	}
`;

export const MainWrapper = styled.div<MainWrapperStylesProps>`
	width: 100%;
	padding: 10px;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.lg}) {
		overflow-x: scroll;
	}
`;

export const ContentWrapper = styled.div`
	margin: 26px 0;
	overflow-x: scroll;
	white-space: nowrap;
	width: 100%;

	::-webkit-scrollbar {
		display: none;
	}

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		margin: 0;
		flex-direction: column;
	}
`;

export const HighlightsBox = styled.div`
	overflow-x: scroll;

	${hideScrollbar}
`;
